import { environment } from '../../../environments/environment';
import { Action, createReducer, on } from '@ngrx/store';

import { AES, enc } from 'crypto-js';

import * as fromAppActions from './app.actions';

export interface AppState {
	authenticated: boolean;
	user: any;
	logging: boolean;
}

export const initialState: AppState = {
	logging: false,
	user: {
		idToken:
			localStorage.getItem('idToken') !== null
				? AES.decrypt(
						localStorage.getItem('idToken'),
						environment.AES_KEY
				  ).toString(enc.Utf8)
				: undefined,

		accessToken:
			localStorage.getItem('accessToken') !== null
				? AES.decrypt(
						localStorage.getItem('accessToken'),
						environment.AES_KEY
				  ).toString(enc.Utf8)
				: undefined,
	},
	authenticated: localStorage.getItem('idToken') !== null ? true : false,
};

const appStateReducer = createReducer(
	initialState,
	on(fromAppActions.doLogin, (state) => ({
		...state,
		logging: true,
	})),
	on(fromAppActions.doLoginSuccess, (state, { user }) => ({
		...state,
		logging: false,
		authenticated: true,
		user: {
			...state.user,
			...user,
		},
	})),
	on(fromAppActions.doLoginFailure, (state) => ({
		...state,
		logging: false,
	}))
);

export function reducer(state: AppState, action: Action): AppState {
	return appStateReducer(state, action);
}
